import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ChangeDetectorRef } from '@angular/core';
import { log } from 'console';
 
@Component({
  selector: 'app-exam-timetable',
  templateUrl: './exam-timetable.component.html',
  styleUrls: ['./exam-timetable.component.scss']
})
export class ExamTimetableComponent implements OnInit {
  ExamTimeTable: FormGroup;
  ExamTTSearchForm;
  ExamList: any;
  examList: any;
  ExamFilterList: any;
  dialogRef: MatDialogRef<any>;
  ExmTimeTable: [];
  ExamArray: FormArray;
  submitpayload: any;
  Time: string;
  Totime: string;
  maxTime: string;
  maxDate: Date;
  date: any;
  holidayDate: any;
  // holidayDates: Date[] = [];
  holidayDates: { FromDate: Date, ToDate: Date, HolidayName: string }[] = [];
  time: any;
  date2: any;
  time2: any;
  SId: any;
  arr
  SessionNo: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  errMsg: any;
  selectedHoliday: any;
  BtnDisable=false;
  examRecords: any;
  constructor(public datepipe: DatePipe,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private router: Router, private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private cdr: ChangeDetectorRef
   ) { }
 
  istableShow = false;
  currentdate: any;
 
  userPermission: any;
  utp: string;
  exTimeUpdate = true;
  exTimeCreate = true;
  ngOnInit(): void {
 
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      // this.fetchSecretData();
      this.umsService.getSecretData().subscribe((res) => {
        this.SessionNo = res.projectPharam['SnNo'];
        this.fetchExamSchedule(this.SessionNo);
      }
      );
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fetchExamSchedule(this.SessionNo);
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam-Timetable' && element.PCreate == false) {
          this.exTimeCreate = false;
        }
        if (element.PageName == 'New-Exam-Code' && element.PUpdate == false) {
          this.exTimeUpdate = false;
        }
      });
    }
    window.scroll(0, 0);
    this.istableShow = false;
    this.currentdate = new Date();
    this.maxDate = new Date(3000, 12, 31);
    this.ExamTimeTable = this.fb.group({
      Exam: new FormControl('',Validators.required),
      // Date: new FormControl(''),
      // EtTime: new FormControl(''),
      // EtTimeTo: new FormControl(''),
      // EsId: new FormControl(''),
      // EsName: new FormControl(''),
      // EtSubCode: new FormControl(''),
      // HdCode: new FormControl(''),
      // StrName: new FormControl(''),
      // EsShName: new FormControl(''),
      // StrCode: new FormControl(''),
      // ShId: new FormControl(this.SId),
      ExamArray: new FormArray([]),
    });
this.getHoliday();
  }
 
  // fetchSecretData() {
  //   this.umsService.getSecretData().subscribe((res) => {
  //     this.SessionNo = res.projectPharam['SnNo'];
  //     this.fetchExamSchedule(this.SessionNo);
  //     }
  //   );
  // }
 
  getExamArrayControls() {
    return (this.ExamTimeTable.get('ExamArray') as FormArray).controls;
  }
 
  condition() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      if (element.EtTime > element.EtTimeTo) {
        console.error('invalid data');
        this.ExamTimeTable.get('EtTimeTo').setErrors({
          'SameTimeError': true
        })
      }
      else if (element.EtTime == element.EtTimeTo) {
        console.error('invalid data', element.EtTime + element.EtTimeTo);
        this.ExamTimeTable.get('EtTimeTo').setErrors({
          'SameTimeError': true
        })
      }
      else {
        this.ExamTimeTable.controls['EtTimeTo'].setErrors(null)
      }
      if (element.EtTimeTo == '23:59') {
        console.error('invalid data');
        this.ExamTimeTable.get('EtTimeTo').setErrors({
          'InValidTimeError': true
        })
      }
    });
  }
 
  condition2() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      this.ExamTimeTable.controls['EtTimeTo'].setErrors(null)
      if (element.Date < this.currentdate) {
        this.ExamTimeTable.get('Date').setErrors({
          'InValidDate': true
        })
      }
    });
 
 
  }
 
  condition1() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      if (element.EtTime == '23:59') {
        this.ExamTimeTable.get('EtTime').setErrors({
          'InValidTimeError': true
        })
      }
    });
  }
 
  addnewdata(e) {
 
    const creds = this.ExamTimeTable.controls.ExamArray as FormArray;
    creds.clear();
    e.forEach((element, i) => {
 
      this.date = element.EtTime.split('T');
      this.time = this.date[1].split(':00.000Z');
      this.date2 = element.EtTimeTo.split('T');
      this.time2 = this.date2[1].split(':00.000Z');
      let da = this.date;
      this.date = this.datepipe.transform(da, 'yyyy-MM-dd');
      if (element.EtTime == "1900-01-01T00:00:00.000Z" && element.EtTimeTo == "1900-01-01T00:00:00.000Z") {
        creds.push(
          this.fb.group({
            Date: new FormControl('', [Validators.required]),
            EtTime: new FormControl('', [Validators.required]),
            EtTimeTo: new FormControl('', [Validators.required]),
            EsName: new FormControl(element.EsName),
            EtSubCode: new FormControl(element.SubCode),
            HdCode: new FormControl(element.HdCode),
            EsId: new FormControl(element.EsId),
            StrName: new FormControl(element.StrName),
            EsShName: new FormControl(element.EsShName),
            StrCode: new FormControl(element.StrCode),
            ShId: new FormControl(this.SId)
          })
        );
      }
      else {
 
        creds.push(
          this.fb.group({
            Date: new FormControl(this.date, [Validators.required]),
            EtTime: new FormControl(this.time[0], [Validators.required]),
            EtTimeTo: new FormControl(this.time2[0], [Validators.required]),
            EsName: new FormControl(element.EsName),
            EtSubCode: new FormControl(element.SubCode),
            HdCode: new FormControl(element.HdCode),
            EsId: new FormControl(element.EsId),
            StrName: new FormControl(element.StrName),
            EsShName: new FormControl(element.EsShName),
            StrCode: new FormControl(element.StrCode),
            ShId: new FormControl(this.SId)
          })
        );
      }
    });
 
  }
 
  addNewRowPrepopulate(e) {
    this.spinner.hide()
    const creds = this.ExamTimeTable.controls.ExamArray as FormArray;
    creds.clear();
    e.forEach((element, i) => {
      this.date = element.EtTime.split('T');
      this.time = this.date[1].split(':00.000Z');
      this.date2 = element.EtTimeTo.split('T');
      this.time2 = this.date2[1].split(':00.000Z');
      let da = this.date;
      this.date = this.datepipe.transform(da, 'yyyy-MM-dd');
 
      creds.push(
        this.fb.group({
          Date: new FormControl('', [Validators.required]),
          EtTime: new FormControl('', [Validators.required]),
          EtTimeTo: new FormControl('', [Validators.required]),
          EsName: new FormControl(element.EsName),
          EtSubCode: new FormControl(element.SubCode),
          HdCode: new FormControl(element.HdCode),
          EsId: new FormControl(element.EsId),
          StrName: new FormControl(element.StrName),
          EsShName: new FormControl(element.EsShName),
          StrCode: new FormControl(element.StrCode),
          ShId: new FormControl(this.SId)
        })
      );
    });
  }
 
  checkToTime(e): ValidatorFn {
    return (control: FormControl): { [key: string]: any } | null => {
      let payload = this.ExamTimeTable.value
      if (payload.ExamArray[e]) {
        const EtTime = payload.ExamArray[e]['EtTime'];
        const EtTimeTo = control.value;
        if (EtTime > EtTimeTo) {
          return { 'toTimeBeforeFromTime': true };
        } else if (EtTime < EtTimeTo) {
          return { 'fromTimeBeforetoTime': true };
        }
        else if (EtTime == EtTimeTo) {
          return { 'SameTime': true }
        }
        return null;
      };
    }
 
  }
  // checkTime(e): ValidatorFn {
  //   return (control: FormControl): { [key: string]: any } | null => {
  //      let payload = this.ExamTimeTable.value
  //       if(payload.ExamArray[e]){
  //        const EtTimeTo =  payload.ExamArray[e]['EtTimeTo'];
  //        const EtTime = control.value;
  //         if (EtTimeTo < EtTime) {
  //         return { 'toTimeBeforeFromTime': true };
  //         }
  //         return null;
  //         };
  //       }
  //  }
  checkvalidation(e) {
    return e.controls['EtTimeTo'].touched && e.controls['EtTimeTo'].errors?.toTimeBeforeFromTime;
  }
  checkvalidationtime(e) {
    return e.controls['EtTime'].touched && e.controls['EtTime'].errors?.toTimeBeforeFromTime;
  }
  checkvalidation1(e) {
    return e.controls['EtTimeTo'].touched && e.controls['EtTimeTo'].errors?.SameTime;
  }
  checkvalidationtime1(e) {
    return e.controls['EtTime'].touched && e.controls['EtTime'].errors?.SameTime;
  }
 
  getTable(item) {
    this.ExamList = [];
    this.istableShow = true;
    const payload = {};
    payload['ShId'] = item.ShId;
    this.SId = item.ShId;
    if(item.ShStatus == 'U'){
      this.BtnDisable = true;
    }else{
      this.BtnDisable = false;
    }
    
    this.getCenterAllocation(item.ShId)
    this.umsService.getExamTT(payload).subscribe(res => {
      this.ExamList = res.data;
      this.addnewdata(this.ExamList)
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })
  }
 

  getTable2(item) {
    this.ExamList = [];
    this.istableShow = true;
    const payload = {};
    payload['ShId'] = item;
    // this.SId = item.ShId;
    if(item.ShStatus == 'U'){
      this.BtnDisable = true;
    }else{
      this.BtnDisable = false;
    }
    
    this.getCenterAllocation(item)
    this.umsService.getExamTT(payload).subscribe(res => {
      this.ExamList = res.data;
      this.addnewdata(this.ExamList)
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })
  }
 
  fetchExamSchedule(SnNo) {
    this.spinner.show();
    const payload = {};
    payload['ShSnNo'] = SnNo
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShStatus'] = "";
    // payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    this.umsService.getExamSch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.ExamFilterList = this.examList.slice();
      }
      else {
        this.spinner.hide();
        this.examList = []
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.examList = []
    })
  }
 
  submit() {
    this.spinner.show();
    this.submitpayload = this.ExamTimeTable.value;
    let arr = [];
    arr = this.submitpayload.ExamArray
    let iserror = false;
    // payload['SnNo'] = this.SessionNo;
    var bar = new Promise<void>((resolve, reject) => {
      arr.forEach((element, index, array) => {
        let da = element.Date;
        element.Date = this.datepipe.transform(da, 'yyyy-MM-dd');
        this.Time = element.Date + 'T' + element.EtTime + ':00.000Z'
        this.Totime = element.Date + 'T' + element.EtTimeTo + ':00.000Z'
        element.EtTime = this.Time;
        element.EtTimeTo = this.Totime;
        // element.SnNo = this.SessionNo;
        let arr1 = [];
        this.umsService.submitExamTT(element).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            this.spinner.hide();
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            this.spinner.hide();
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.getTable2(this.ExamTimeTable.value.Exam);
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
 
      }
    });
  }
 
  print() {
    let submitpayload = this.ExamTimeTable.value;
 
    let payload1 = {}
    payload1['MenuName'] = 'ExamTimeTable';
    // payload1['ShId'] = submitpayload.Exam
 
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 310,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": submitpayload.Exam,
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
      "InstituteCode" : ''
    }
 
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  redirect(to): void {
    this.router.navigate([to]);
  }
 
  timeValidation(e, i) {
    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let fromTime = e.value.EtTime;
    let toTime = e.value.EtTimeTo;
    if (e.value.Date == '') {
      let data = {}
      data['message'] = 'Select First Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('EtTime').setValue('');
    }
 
 
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    let previousTime = taskListArrays.controls[i - 1].value['EtTime']
    let currentRowTime = taskListArrays.controls[i].value['EtTime'];
    let previousDate = taskListArrays.controls[i - 1].value['Date']
    let currentRowDate = taskListArrays.controls[i].value['Date'];
    let previousToTime = taskListArrays.controls[i - 1].value['EtTimeTo']
 
    if (previousTime == currentRowTime && previousDate == currentRowDate) {
      let data = {}
      data['message'] = 'Time selected'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
 
    }
 
    this.arr.forEach(element => {
 
      if (toTime != "00:00" && toTime != '' && fromTime >= toTime && element.EtTime != '' && element.EtTimeTo != '') {
        let data = {}
        data['message'] = 'From Time Is Not Greater Than To Time'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(i).get('EtTime').setValue('');
      }
      else if (i !== 0 && e.value.Date == element.Date && previousTime == currentRowTime && element.Date != '') {
        let data = {}
        data['message'] = 'Date And Time selected'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(i).get('EtTime').setValue('');
      }
      else if (i !== 0 && previousDate == currentRowDate && currentRowTime <= previousToTime) {
        let data = {}
        data['message'] = 'Time Is Invalid'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(i).get('EtTime').setValue('');
      }
    })
 
  }
 
 
 
  timeValidation2(e, i) {
    let fromTime = e.value.EtTime;
    let toTime = e.value.EtTimeTo;
    if (fromTime == '' || e.value.Date == '') {
      let data = {}
      data['message'] = 'First Select Date And From Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('EtTimeTo').setValue('');
    }
    else if (fromTime = '') {
      let data = {}
      data['message'] = 'First Select From Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('EtTimeTo').setValue('');
    }
    else if (e.value.EtTime >= e.value.EtTimeTo) {
      let data = {}
      data['message'] = 'To Date Is Not Less Than From Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('EtTimeTo').setValue('');
    }
  }
 
 
  onDateClick(e, i) {
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    let previousfromTime = taskListArrays.controls[i - 1].value['EtTime']
    let previousToTime = taskListArrays.controls[i].value['EtTimeTo'];
    let previousDate = taskListArrays.controls[i - 1].value['Date']
    if (i !== 0 && previousfromTime == '' || previousToTime == '' || previousDate == '') {
      let data = {}
      data['message'] = 'First Select Previous Date And Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('Date').setValue('');
    }
  }
 
 
  save() {
    this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
    if (this.ExamTimeTable.invalid) {
      this.ExamTimeTable.get('Exam').markAsTouched();
      this.arr.controls.forEach(element => {
 
        element.get('Date').markAsTouched();
        element.get('EtTime').markAsTouched();
        element.get('EtTimeTo').markAsTouched();
        // element.get('FeeAmount').markAsTouched();
 
      })
    }
    else {
      this.submit()
    }
  }
 
  datechange1(i) {
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    // this.isDatePassed(taskListArrays.controls[i].value['Date'])
    let formattedDate = this.datepipe.transform(taskListArrays.controls[i].value['Date'], 'yyyy-MM-dd');
 
    // if(taskListArrays.controls[i].value['Date'] < this.currentdate || formattedDate < this.currentdate){
    //   taskListArrays.controls[i].get('CutOffDate').setErrors({ TodaydateError: true });
    // }
    // else{
    //   taskListArrays.controls[i].get('CutOffDate').setErrors(null);
    // }
    // let Fromdate = taskListArrays.controls[i].value['CutOffDateFrom']
    // let date = taskListArrays.controls[i].value['CutOffDate']
    // if(date <= Fromdate){
    //   taskListArrays.controls[i].get('CutOffDate').setErrors({ dateError: true });
    //   // this.errorcheckValidator(i)
    // }
    // else{
    //   taskListArrays.controls[i].get('CutOffDate').setErrors(null);
    // }
 
  }
 
 
  isDatePassed(cutOffDate: Date): boolean {
    const todayDate = new Date(); // Get today's date
    const cutOff = new Date(cutOffDate); // Parse the cutOffDate into a Date object
 
    // Set time component to 00:00:00 for both dates
    todayDate.setHours(0, 0, 0, 0);
    cutOff.setHours(0, 0, 0, 0);
 
    // Check if cutOffDate is greater than today's date or same as today's date
    return cutOff < todayDate;
  }
 
 
  checkValidation(item, index) {
    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    // let previousRowDate= taskListArrays.controls[index - 1].value['Date'];
    // let previousRowFromTime =taskListArrays.controls[index - 1].value['EtTime'];
    // let previousRowToTime=taskListArrays.controls[index - 1].value['EtTimeTo'];
    // // else if (i !== 0 && item.value.Date == element.Date && previousTime == currentRowTime && element.Date != '') {  
    // let currentRowDate = item.value.Date;
    // let currentRowFromTime =item.value.EtTime;
    // let currentRowToTime = item.value.EtTimeTo;
    if (index != 0) {
      if (item.value.Date == '') {
        let data = {}
        data['message'] = 'First Selected date'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(index).get('EtTime').setValue('');
      }
      for (let i = index; i >= 0; i--) {
        const currentRow = taskListArrays.controls[i];
        //current
        let currentRowDate = currentRow.value.Date;
        let currentRowFromTime = currentRow.value.EtTime;
        let currentRowToTime = currentRow.value.EtTimeTo
 
        //previ
        let previousRowDate = taskListArrays.controls[i - 1].value['Date'];
        let previousRowFromTime = taskListArrays.controls[i - 1].value['EtTime'];
        let previousRowToTime = taskListArrays.controls[i - 1].value['EtTimeTo'];
        let cDate = this.datepipe.transform(currentRowDate, 'yyyy-MM-dd');
        let pDate = this.datepipe.transform(previousRowDate, 'yyyy-MM-dd');
        // && currentRowFromTime == previousRowFromTime
        if (currentRowFromTime == previousRowFromTime) {
          if (cDate == pDate) {
            let data = {}
            data['message'] = 'Date And Time Selected'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
            this.arr.at(index).get('EtTime').setValue('');
 
          }
          // else{
          //   let data = {}
          //   data['message'] = 'Date And Time Selected'
          //   data['title'] = 'Information'
          //   data['icon'] = 'fas fa-close'
          //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          //   this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
          //   this.arr.at(index).get('EtTime').setValue('');
          // }
 
        }
        else if (cDate == pDate && currentRowFromTime <= previousRowToTime) {
          let data = {}
          data['message'] = 'Time Invalid'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
          this.arr.at(index).get('EtTime').setValue('');
 
        }
      }
    }
    else {
      const currentRow = taskListArrays.controls[index];
      //current
      let currentRowDate = item.value.Date;
      let currentRowFromTime = item.value.EtTime;
      let currentRowToTime = item.value.EtTimeTo
 
      if (currentRowDate == '') {
        let data = {}
        data['message'] = 'First Selected date'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(index).get('EtTime').setValue('');
      }
    }
 
 
    const filteredElements = this.arr.filter(element => {
      let fromTime = element.EtTime;
      let toTime = element.EtTimeTo
      //  if(currentRowDate == ''){
      //   let data = {}
      //   data['message'] = 'First Selected date'
      //   data['title'] = 'Information'
      //   data['icon'] = 'fas fa-close'
      //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      //   this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      //   this.arr.at(index).get('EtTime').setValue('');
      //  }
      //  else if(index != 0 && currentRowDate == element.Date && currentRowFromTime == element.EtTime){
      //   let data = {}
      //   data['message'] = 'Date And Time Selected'
      //   data['title'] = 'Information'
      //   data['icon'] = 'fas fa-close'
      //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      //   this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      //   this.arr.at(index).get('EtTime').setValue('');
      //  }
    });
  }
 
 
  dateValidation(item, i) {
    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    let selectedDateControl = taskListArrays.controls[i].get('Date');
    let selectedDate = new Date(selectedDateControl.value);
    // if(taskListArrays.controls[i].value['Date'].getDay() == 0){
    //   let data = {};
    //       data['message'] = 'The Selected Day Is Sunday. Do You Still Want To Proceed?';
    //       data['title'] = 'Alert';
    //       data['icon'] = 'fa fa-question';
    //       this.dialogRef =
    //         this.modalPopupService.openPopup<ConformationModelComponent>(
    //           ConformationModelComponent,
    //           data
    //         );
    //       this.dialogRef.afterClosed().subscribe((result) => {
    //         if (result === 'yes') {
    //           taskListArrays.controls[i].get('Date').setValue(taskListArrays.controls[i].value['Date']);
    //         } else {
    //           taskListArrays.controls[i].get('Date').setValue('');
    //         }
    //       });
    // }


    let isHoliday = this.holidayDates.some(holiday => {
      let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      let currentDate = selectedDate.setHours(0, 0, 0, 0);
      return currentDate >= FromDate && currentDate <= ToDate;
    });

    if (isHoliday) {
      // Find all holidays that overlap with the selected date
      let overlappingHolidays = this.holidayDates.filter(holiday => {
        let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
        let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
        let currentDate = selectedDate.setHours(0, 0, 0, 0);
        return currentDate >= FromDate && currentDate <= ToDate;
      });
  
      // Join holiday names
      let holidayNames = overlappingHolidays.map(holiday => holiday.HolidayName).join(', ');
  
      let data = {
        message: `The Selected Day Is ${holidayNames}. Do You Still Want To Proceed?`,
        title: 'Alert',
        icon: 'fa fa-question'
      };
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result !== 'yes') {
          selectedDateControl.setValue('');
          // selectedDateControl.markAsUntouched();
        }
      });
    } else {
      selectedDateControl.setValue(selectedDateControl.value);
    }
  
    // if (isHoliday) {
    //   let holiday = this.holidayDates.find(holiday => {
    //     let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
    //     let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
    //     let currentDate = selectedDate.setHours(0, 0, 0, 0);
    //     return currentDate >= FromDate && currentDate <= ToDate;
    //   });
  
    //   if (holiday) {
    //     this.selectedHoliday = holiday;
    //     let data = {
    //       message: `The Selected Day Is ${this.selectedHoliday.HolidayName}. Do You Still Want To Proceed?`,
    //       title: 'Alert',
    //       icon: 'fa fa-question'
    //     };
    //     this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    //     this.dialogRef.afterClosed().subscribe((result) => {
    //       if (result !== 'yes') {
    //         selectedDateControl.setValue('');
    //         // selectedDateControl.markAsUntouched();
    //       }
    //     });
    //   }
    // } else {
    //   selectedDateControl.setValue(selectedDateControl.value);
    // }




    let previousRowDate = taskListArrays.controls[i - 1].value['Date'];
    let previousRowFromTime = taskListArrays.controls[i - 1].value['EtTime'];
    let previousRowToTime = taskListArrays.controls[i - 1].value['EtTimeTo'];
    if (i != 0 && (previousRowDate == '' || previousRowFromTime == '' || previousRowToTime == '')) {
      let data = {}
      data['message'] = 'First Select Previous Row Date and Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('Date').setValue('');
    }
 
  
  }


  getHoliday() {
  const payload = {};
  payload['SnNo'] = '';
    this.umsService.getExamHoliday(payload).subscribe(res => {
      if (res.status) {
        this.holidayDates = res.data.map(item => ({
          FromDate: new Date(item.FromDate),
          ToDate: new Date(item.ToDate),
          HolidayName: item.HolidayName
        }));
        this.cdr.detectChanges(); 
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  dateClass = (d: Date | null): string => {
    const date = d || new Date();
    const holiday = this.holidayDates.find(holiday => {
      const FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      const ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      const currentDate = date.setHours(0, 0, 0, 0);
      return currentDate >= FromDate && currentDate <= ToDate;
    });
    if (holiday) {
      this.selectedHoliday = holiday; 
      return 'holiday-date';
    } else {
      return '';
    }
  }


  getCenterAllocation(ShId){
    this.spinner.show();
    let payload = {};
    payload['EcShId'] = ShId;
    payload['EcInCode'] = 20;
    payload['EcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.examRecords = res.data;
          let allStatusU = true;
          this.examRecords.forEach(element => {
            if (element.EcInCode === 20 && element.EcStatus !== "U") {
              allStatusU = false;
          }
          if (allStatusU) {
            this.BtnDisable = true;
        } else {
          this.BtnDisable = false;
        }
          });
        } 
        else {
       
        }
      },
      (ERROR: HttpErrorResponse) => {
       
        this.spinner.hide();
      }
    );

  }
}

